export const DISCOUNT_CODE_SEARCH_PARAM_NAME = 'discount_code';

export const getDiscountCodeFromSearchParams = (
  params: [string, string][],
): string | undefined => params.find(([key]) => key === DISCOUNT_CODE_SEARCH_PARAM_NAME)?.[1];
